import * as actionTypes from './../../actionTypes/checkout';

const initalState = {
  checkoutBasicData: {
    address: {
      addressType: 'billing',
      addressline1: '',
      addressline2: '',
      alternatePhone: '',
      city: '',
      country: 'IN',
      firstName: '',
      lastName: '',
      email: '',
      floor: 0,
      gender: '',
      landmark: '',
      liftAvailable: false,
      locality: '',
      phone: '',
      postcode: '',
      state: '',
      comment: ''
    },
    giftMessage: {
      from: '',
      message: '',
      to: ''
    }
  },
  paymentMethods: null,
  thirdTabKey: '',
  leadSource: false,
  preSalesInfo: null,
  checkoutStepKey: 1,
  paymentData: null,
  paymentError: null,
  frameProduct: true,
  allowCartModification: true,
  showOOS: false
};

export default function checkout(prevState = initalState, action) {
  switch (action.type) {
    case actionTypes.CHECKOUT_STEP_KEY:
      return Object.assign({}, prevState, { checkoutStepKey: action.key });
    case actionTypes.SELECTED_PAYMENT_METHOD:
      return Object.assign({}, prevState, { selectedPaymentMethod: action.key });
    case actionTypes.SAVE_GUEST_INFO:
      return Object.assign({}, prevState, { guestInfo: action.data });
    case actionTypes.MANAGE_CHECKOUT_DATA:
      return Object.assign({}, prevState, { checkoutBasicData: action.data });
    case actionTypes.CART_MODIFICATION:
      return Object.assign({}, prevState, { allowCartModification: action.allow });
    case actionTypes.CARTSTEP3:
      return Object.assign({}, prevState, { pmLoading: true, loaded: false, paymentMethodLoadError: null });
    case actionTypes.CARTSTEP3_LOAD:
      return Object.assign({}, prevState, { pmLoading: false, loaded: true, paymentMethods: action.result.result, paymentMethodLoadError: null });
    case actionTypes.CARTSTEP3_FAIL:
      return Object.assign({}, prevState, { pmLoading: false, loaded: true, paymentMethods: null, paymentMethodLoadError: action.error });
    case actionTypes.LOAD_PAYMENT_SUCCESS:
      return Object.assign({}, prevState, { loadingPlaceOrder: true });
    case actionTypes.PAYMENT_SUCCESS:
      return Object.assign({}, prevState, { loadingPlaceOrder: false, paymentData: action.result, paymentError: null });
    case actionTypes.PAYMENT_FAIL:
      return Object.assign({}, prevState, { loading: false, loaded: true, loadingPlaceOrder: false, paymentData: null, paymentError: action.error });
    case actionTypes.SAVE_SHIPPING_ADDRESS:
      return Object.assign({}, prevState, { loading: true, loaded: false, shippingLoader: true, saveShippingAddress: null, saveShippingError: null });
    case actionTypes.SAVE_SHIPPING_ADDRESS_SUCCESS:
      return Object.assign({}, prevState, { loading: false, loaded: true, shippingLoader: false, saveShippingAddress: action.result, saveShippingError: null });
    case actionTypes.SAVE_SHIPPING_ADDRESS_FAIL:
      return Object.assign({}, prevState, { loading: false, loaded: true, shippingLoader: false, saveShippingAddress: null, error: action.error, saveShippingError: action.error });
    case actionTypes.GET_DELIVERY_OPTIONS:
      return Object.assign({}, prevState, { deliveryData: null, deliveryLoader: true });
    case actionTypes.GET_DELIVERY_OPTIONS_SUCCESS:
      return Object.assign({}, prevState, { deliveryData: action.result, deliveryLoader: false });
    case actionTypes.GET_DELIVERY_OPTIONS_FAIL:
      return Object.assign({}, prevState, { deliveryData: null, deliveryLoader: false });
    case actionTypes.SHOW_OOS:
      return Object.assign({}, prevState, { showOOS: action.val });
    case actionTypes.GET_PRESALE_INFO_SUCCESS:
      return Object.assign({}, prevState, { preSalesInfo: action.result, leadSource: Boolean(action.result && action.result.result.attrs.preSalesUserIsLoggedIn) });
    case actionTypes.GET_PRESALE_INFO_FAIL:
      return Object.assign({}, prevState, { preSalesInfo: null, leadSource: false });
    case actionTypes.LOGOUT_USER:
      return initalState;
    case actionTypes.GET_CAPTCHA:
      return Object.assign({}, prevState, { captcha: { ...prevState.captcha, loading: true } });
    case actionTypes.GET_CAPTCHA_SUCCESS:
      return Object.assign({}, prevState, { captcha: { loading: false, ...action.result } });
    case actionTypes.GET_CAPTCHA_FAIL:
      return Object.assign({}, prevState, { captcha: { loading: false, data: null } });
    default:
      return prevState;
  }
}
